interface Props {
  eyebrow?: string;
  title: string;
  description?: string;
  actions?: React.ReactNode;
}

export function PageHeader({ eyebrow, title, description, actions }: Props) {
  return (
    <div className="flex items-end justify-between gap-6 pb-6 border-b border-border">
      <div>
        {eyebrow && (
          <p className="font-mono text-xs uppercase tracking-widest text-text-muted">
            {eyebrow}
          </p>
        )}
        <h1 className="text-3xl mt-1">{title}</h1>
        {description && (
          <p className="text-text-secondary mt-2 max-w-2xl text-sm">{description}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
